
export default function() {
  // eslint-disable-next-line vue/return-in-computed-property
  const type = () => {
    if (window.innerWidth < 550) return 'xs'
    if (window.innerWidth > 549 && window.innerWidth < 1200) return 'md'
    if (window.innerWidth > 1199) return 'lg'
  }

  const width = () => { return window.innerWidth }

  return { width, type }
}
